exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tools__list {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-flow: row nowrap;\r\n            flex-flow: row nowrap;\r\n\r\n    font-size: 1.2rem;\r\n}\r\n.tools__item {\r\n    height: 45px;\r\n    padding: 25px 10px 5px;\r\n\r\n    background-color: #F1F1F1;\r\n\r\n    cursor: pointer;\r\n}\r\n.tools__item_delete {\r\n    background: url('/assets/img/delete.svg') center 5px/15px 15px no-repeat;\r\n}\r\n.tools__item_not-spam {\r\n    background: url('/assets/img/not-spam.svg') center 5px/15px 15px no-repeat;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/tools/spam-letter-tools/spam-letter-tools.component.css
// module id = 606
// module chunks = 1